import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { gsap } from "gsap";
import { Subscription } from 'rxjs';
import { LotteryService } from 'src/app/services';

@Component({
  selector: 'app-usp-hero',
  templateUrl: './usp-hero-spot.component.html',
  styleUrls: ['./usp-hero-spot.component.scss']
})
export class UspHeroComponent implements OnInit, OnDestroy {

  public saleStop: any = {};
  public saleStopDate: Date;

  private router: Router;
  private readonly lotteryService: LotteryService;
  private salestopSubscription = new Subscription();

  public constructor(router: Router, lotteryService: LotteryService) { 
    this.router = router;
    this.lotteryService = lotteryService;
  }

  public ngOnInit(): void
  {
    this.animateHeader();
    this.getNextSaleStop();
  }

  public animateHeader(): void
  {
    gsap.registerPlugin(SplitText);

    // create a reusable effect that swaps text
    gsap.registerEffect({
      name: "swapText",
      effect: (targets, config) => {
        let tl = gsap.timeline({delay: config.delay});
        tl.to(targets, {opacity: 0, duration: config.duration / 2});
        tl.add(() => targets[0].innerText = config.text);
        tl.to(targets, {opacity: 1, duration: config.duration});
        return tl;
      },
      defaults: {duration: 0.5}, 
      extendTimeline: true
    });
    
    var tl = gsap.timeline({repeat: -1, repeatDelay: 0.3, defaults: { duration: 0.5 }});
    
    var mySplitChar = new SplitText("#splitit", {type:"chars"})
    var chars = mySplitChar.chars;

    gsap.set("#splitit", {transformOrigin:"center center"});
  
    tl.add("start");
    
    tl.fromTo(chars, {autoAlpha: 0, y: 400, rotate: 0},
      { duration: 1, 
        stagger: 0.1,
        autoAlpha: 1,
        y: "random(0, 20)",
        rotate: "random(-10, 10, 5)",     
        ease: "power4",
        })
      .from(".swapTxt", {autoAlpha: 0, ease: "power4.in"}, "-=0.7") 
      .to(chars, {rotate: "random(-10, 10, 5)", y: "random(0, -10)", duration: 2, ease: "power1.inOut"}, "-=0.3")
      .to(chars, {rotate: "random(-10, 10)", y: -500, ease: "power4.in"}, "-=0.3")
      .add("start-dis")
      .swapText(".swapTxt", {text: "mio. i puljen"})
      .fromTo(".dis-4", {autoAlpha:0, y: 500, rotate: 0},
      {
        autoAlpha: 1,
        y: 0,
        rotate: -25,     
        ease: "power4",
        }, "start-dis+=0.2")
      .fromTo(".dis-6", {autoAlpha:0, y: 500, rotate: 0},
        {
          autoAlpha: 1,
          y: -60,
          rotate: 20,     
          ease: "power4",
          }, "start-dis+=0.1")
      .to(".dis-4", {rotate: -15, y: -20, duration: 2, ease: "power1.inOut"}, ">")   
      .to(".dis-6", {rotate: 5, y: -80, duration: 2, ease: "power1.inOut"}, "<") 
      .from(".txt3", {autoAlpha:0}, "<")
      .to(".swapTxt, .txt3, .dis-4, .dis-6", {y: -500, ease: "power4.in", autoAlpha:0, delay: 10})
      .swapText(".swapTxt", {text: "Glade vindere"});
     //console.log(tl.duration());
  }

  public getNextSaleStop(): void
  {
    this.lotteryService.getSaleStop().subscribe((salestop) => {
      this.saleStop = salestop;

      const seconds = parseInt(salestop.Seconds, 10) || 0;
      const minutes = parseInt(salestop.Minutes, 10) || 0;
      const hours = parseInt(salestop.Hours, 10) || 0;
      const days = parseInt(salestop.Days, 10) || 0;

      const x = new Date();
      x.setDate(x.getDate() + days);
      x.setHours(x.getHours() + hours);
      x.setMinutes(x.getMinutes() + minutes);
      x.setSeconds(x.getSeconds() + seconds);

      this.saleStopDate = x;
    });
  }

  public showPage(): void
  {
    this.router.navigate(['/lodder-til-salg/lodder']);
  }

  public ngOnDestroy(): void
  {
    this.salestopSubscription.unsubscribe();
  }
}
